import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import fileDownload from 'js-file-download';
// 다국어
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
// @mui

import axios from 'axios';
import httpClient from '../../utils/httpClient';
import PageHeader from '../../components/sectionComponent/PageHeader';
import downloadFile from '../../utils/apis/download/downloadFile';
// ----------------------------------------------------------------------
const DownloadButton = styled(Button)({
  marginTop: '60px',
  fontSize: '1.2rem',
  fontWeight: 500,
  fontFamily: 'nanumSquare',
  padding: '1rem 4rem',
});

export default function DownloadPage() {
  // 다국어
  const { t } = useTranslation(['page']);
  const { t: tImg } = useTranslation(['img']);

  const navigate = useNavigate();
  const fileName = process.env.REACT_APP_DOWNLOAD_FILE_NAME;
  const rainDropVersion = fileName.match(/v\d+\.\d+\.\d+/);

  const handleDownload = async () => {
    // axios
    //   .get('http://210.220.65.132:82/boards/download/Raindrop-Installer-2.6.2.exe', {
    //     responseType: 'arraybuffer',
    //   })
    //   .then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', fileName); // or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   });
    if (!sessionStorage.getItem('login_info')) {
      alert(t('로그인 후 이용 가능합니다.'));
      navigate('/login', { replace: true });
    } else {
      setOpen(true);
      try {
        axios
          .get(`${process.env.REACT_APP_SERVER_URL}/boards/download/${fileName}`, {
            responseType: 'arraybuffer',
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // or any other extension
            document.body.appendChild(link);
            link.click();
          });
      } catch (error) {
        alert('err');
        console.error(error);
      }
      setOpen(false);
    }
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      <CssBaseline />
      <Helmet>
        <title> {t('다운로드')} | RainDrop </title>
      </Helmet>
      <PageHeader data={'다운로드'} />
      <Box
        sx={{
          width: '100%',
          background: `url(/images/download/download_bg.png) no-repeat 100% 100%`,
          flex: 1,
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            marginTop: '80px',
            background: `url(${tImg('download_img_1')}) no-repeat bottom center`,
            paddingBottom: '400px',
          }}
        >
          <h1 style={{ fontWeight: 300, lineHeight: 1.3 }}>
            {t('복잡한 치과 기공소 관리')}
            <br />
            {t('레인드롭으로 쉽고 간편하게')}
          </h1>
          <h4 style={{ marginTop: '20px' }}>{t('편리한 치과 기공소 관리 비용 걱정 없이 무료로 이용하세요.')}</h4>
          <DownloadButton sx={{ marginTop: '60px' }} variant="contained" onClick={handleDownload}>
            {t('지금 바로 다운받기')}
          </DownloadButton>

          <p style={{ marginTop: '10px' }}>{rainDropVersion} (28 MB) for Windows</p>
        </Container>
      </Box>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
